import { useStores } from '../hooks';
import { getTranslation } from '../shared/language';

export const useLanguage = (lang = null) => {
  const {
    ProviderStore: { language },
  } = useStores();

  const {
    messages,
    validations: { invalidUserPwdText },
    values: { selectOneValueText },
    screen: {
      login: {
        headerText,
        loginButtonText,
        userNameLabel,
        passwordLabel,
        auctionLabelText,
        laneLabelText,
        selectScreenHeaderText,
        switchAuctionButtonText,
        logoutButtonText,
        helpLabelText,
        providerSelectText,
      },
    },
  } = getTranslation(lang || language);

  return {
    messages,
    invalidUserPwdText,
    selectOneValueText,
    headerText,
    loginButtonText,
    userNameLabel,
    passwordLabel,
    auctionLabelText,
    laneLabelText,
    selectScreenHeaderText,
    switchAuctionButtonText,
    logoutButtonText,
    helpLabelText,
    providerSelectText,
  };
};

export default useLanguage;
